<template>
  <div class="full-height">
    <div class="row container-crud q-px-sm">
      <div class="fit">
        <q-card class="q-px-sm">
          <q-card-section class="q-px-lg container-companyPage full-width row">
            <span v-if="elements.length == 1" class="col-12">
              <jt-dynamic-form
                ref="dynamicForm"
                :inputs="inputs"
                :relacionamentos="elements[0].relacionamentos"
                :model="elements[0].dadosForm"
                :interface="elements[0].nmInterface"
                form-class="form dynamic"
                @search-found="selections"
              />
            </span>
          </q-card-section>
          <q-card-section class="q-px-lg q-col-gutter-x-md row">
            <span
              v-for="(item, index) in organizationalStructureLevelCombos"
              :key="item.id"
              class="col-4 "
            >
              <jt-select
                :key="item.id"
                v-model="item.value"
                :options="getOptions(item.list, index)"
                emit-value
                map-options
                clearable
                outlined
                @input="onSelectChange(item.organizationalStructureLevel)"
                :float-label="item.label"
              />
            </span>
          </q-card-section>
        </q-card>
      </div>
    </div>

    <div
      class="row full-width q-col-gutter-lg justify-center q-py-lg"
      v-if="forms[0] && forms[0].buttons.length > 0"
    >
      <div class="col-lg-2 col-md-3">
        <q-btn class="full-width" color="grey-7" @click="limparForm"
          ><translate>CLEAN</translate></q-btn
        >
      </div>
      <div
        v-for="(button, i) in forms[0].buttons"
        :key="i"
        class="col-lg-2 col-md-3"
      >
        <q-btn
          class="full-width"
          color="info"
          @click="actionButton(button)"
        >
          <q-icon
            v-if="button.icon"
            :name="button.icon"
            size="18px"
            class="position-icon-filter"
          />
          {{ button.label }}
        </q-btn>
      </div>
    </div>
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtCrud, JtSelect, JtDataGrid } from 'jtech-webcomps'
import { repository } from 'jtech'
const { page } = JtCrud

@Component({
  mixins: [page],
  name: 'companyPage',
  components: { JtSelect, JtDataGrid },
  props: {
    name: String,
    forms: { type: Array, required: true },
    params: Object,
    parent: Object
  }
})
export default class CompanyPage extends Vue {
  nmInterface = null;
  organizationalStructureLevelCombos = [];

  beforeMount () {
    this.nmInterface = this.elements[0].nmInterface.split('.')[1]
    this.createorganizationalStructureCombo()
  }

  get tableData () {
    return [this.elements[0].dadosForm]
  }

  getOptions (list, index) {
    let parentId = ''
    if (index > 0) {
      parentId = this.organizationalStructureLevelCombos[index - 1].value
    }
    return list
      .filter(e => !e.parentId || e.parentId == parentId)
      .flatMap(element => [{ value: element.id, label: element.name }])
  }

  get inputs () {
    return this.elements[0].inputs.filter(
      ci => ci.name !== 'organizationalStructure' && ci.type !== 'FILE'
    )
  }

  onSelectChange (organizationalStructureLevel) {
    delete this.elements[0].dadosForm.organizationalStructure
    this.organizationalStructureLevelCombos.forEach(e => {
      if (e.organizationalStructureLevel > organizationalStructureLevel) { delete e.value } else if (e.value) { this.elements[0].dadosForm.organizationalStructure = e.value }
    })
    this.$forceUpdate()
  }

  createorganizationalStructureCombo () {
    const { level, organizationalStructureIds } = this.elements[0].dadosForm
    if (level) {
      this.organizationalStructureLevelCombos = JSON.parse(level)
    }
    if (organizationalStructureIds) {
      const ids = organizationalStructureIds.split(',').reverse()
      this.organizationalStructureLevelCombos.forEach((combo, index) => {
        if (ids[index]) {
          combo.value = parseInt(ids[index])
        }
      })
    }
  }

  async selections (data) {
    const {
      legalEntity,
      available,
      level,
      organizationalStructure,
      integrationCode
    } = this.elements[0].dadosForm

    if (data.legalEntity.idField) {
      const param = { id: legalEntity }
      const { registros } = await repository.resolveDatatableModel(
        'legalEntity.pesquisarSelecao',
        param
      )
      delete registros[0].id

      delete registros[0].idAcaoGrid

      this.elements[0].dadosForm = {
        ...this.elements[0].dadosForm,
        ...registros[0]
      }
    } else {
      this.elements[0].dadosForm = {
        legalEntity,
        available,
        level,
        organizationalStructure,
        integrationCode
      }
    }
    this.$forceUpdate()
  }

  getParams () {
    const dadosForm = this.forms[0].dadosForm
    if (this.nmInterface === 'pesquisar') {
      return { ...dadosForm, ...{ level: null } }
    }
    return dadosForm
  }
}
</script>
<style lang="stylus" scoped>
.container-companyPage{
  .dynamic-form #scroll-area{
    height: calc(24vh - 30px) !important;
  }

  @media only screen and (max-height: 900px) {
  .dynamic-form {
    #scroll-area {
      height: calc(27vh - 20px) !important;
    }
  }
}

@media only screen and (max-height: 850px) {
  .dynamic-form {
    #scroll-area {
      height: calc(30vh - 20px) !important;
    }
  }
}

@media only screen and (max-height: 800px) {
  .dynamic-form {
    #scroll-area {
      height: calc(35vh - 20px) !important;
    }
  }
}

@media only screen and (max-height: 765px) {
  .dynamic-form {
    #scroll-area {
      height: calc(40vh - 30px) !important;
    }
  }
}

@media only screen and (max-height: 650px) {
  .dynamic-form {
    #scroll-area {
      height: calc(45vh - 20px) !important;
    }
  }
}
 }

</style>
